import { FilterChanges } from "./GridFilters";

export function removeEmptyValues(filterChanges: FilterChanges[]) {
	return filterChanges.filter((item) =>
		Array.isArray(item.value)
			? item.value.length > 0
			: item.value?.trim().length > 0);
}
